var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeaker = function SvgSpeaker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.647 1.988a2.483 2.483 0 0 1 2.483 2.483v15.058a2.483 2.483 0 0 1-2.483 2.483H6.353a2.483 2.483 0 0 1-2.482-2.483V4.471a2.48 2.48 0 0 1 2.482-2.483zm-11.294 1.2c-.708 0-1.283.574-1.283 1.283v15.058c0 .708.575 1.282 1.283 1.282h11.294c.708 0 1.282-.574 1.283-1.282V4.471c0-.708-.575-1.283-1.283-1.283zM12 9.618a4.265 4.265 0 1 1 0 8.528 4.265 4.265 0 0 1 0-8.529m0 1a3.265 3.265 0 1 0 0 6.529 3.265 3.265 0 0 0 0-6.53m.01 2.664a.6.6 0 0 1 0 1.2H12a.6.6 0 1 1 0-1.2zm0-7.53a.6.6 0 0 1 0 1.2H12a.6.6 0 0 1 0-1.2z"
  })));
};
export default SvgSpeaker;